import React from 'react';
import styled from '@emotion/styled';
import { DateTime } from 'luxon';
import { useI18n } from '~Hooks';
import { Message } from '@baemingo/table-events/dist/types';

const Wrapper = styled.div`
  color: var(--colorBlueGray800);
`;

const Head = styled.div`
  border-bottom: 1px solid var(--colorBlueGray1000);
  color: var(--colorBlueGray800);
  padding: 16px 16px 10px;
  margin-bottom: 8px;
`;

const MessageWrapper = styled.div`
  padding: 6px 16px;
  color: var(--colorWhite);
  display: flex;
  justify-content: space-between;
`;

interface Props {
  messages: Message[];
}

const Messages: React.FunctionComponent<Props> = ({ messages }) => {
  const { i18n } = useI18n();
  return (
    <Wrapper>
      <Head>{i18n('TM.KitchenMessages')}</Head>
      {messages.map((m) => (
        <MessageWrapper key={m.id}>
          <span>
            {m.message} {m.courseId && <span>{m.courseId}</span>}
          </span>
          {DateTime.fromISO(m.createdAt).toFormat('HH:mm')}
        </MessageWrapper>
      ))}
    </Wrapper>
  );
};

export default Messages;
